import Icon from './Icon'

/**
 * A search input with no placeholder.
 *
 * Placeholder text inside a field reads as a filled-in value at a glance, so
 * the affordance moves to a leading glyph and the accessible name moves to
 * `aria-label`. Same information, none of it pretending to be data.
 */
export default function SearchField({
  value,
  onChange,
  label,
  width,
}: {
  value: string
  onChange: (value: string) => void
  /** The accessible name. Never rendered as text inside the field. */
  label: string
  width?: number | string
}) {
  return (
    <div
      className="row"
      style={{
        gap: 8,
        flex: 'none',
        width,
        padding: '0 10px',
        borderRadius: 'var(--radius-control)',
        background: 'var(--panel-raised)',
        border: 'var(--hairline-width) solid var(--hairline)',
      }}
    >
      <Icon name="search" size={15} style={{ color: 'var(--text-tertiary)', flex: 'none' }} />
      <input
        className="field"
        aria-label={label}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        style={{
          flex: 1,
          minWidth: 0,
          border: 'none',
          background: 'transparent',
          padding: '9px 0',
        }}
      />
    </div>
  )
}
